export default __webpack_public_path__ + "5cdb40b089820639454d90a5e4874aee.png";